import { Component } from '@angular/core';

@Component({
  selector: 'app-dispute-policy',
  templateUrl: './dispute-policy.component.html',
  styleUrls: ['./dispute-policy.component.css'],
  standalone: false
})
export class DisputePolicyComponent {}
